import * as Yup from "yup";

export const bulkInitials = {
    model_id:"",
    esim_provider:"",
    excel_file:null,
    
};
export const bulkFormField = {
  model_id: {
    name: "model_id",
    type: "select",
    label: "Model Name",
    validation: Yup.string().required("Model is required").trim(),
    options: [],
  },
  esim_provider: {
    name: "esim_provider",
    type: "select",
    label: "eSIM Provider",
    validation: Yup.string().required("eSIM Provider is required").trim(),
    options: [],
  },
  excel_file: {
    name: "excel_file",
    type: "file",
    label: "Select the Excel File",
    message: 'Only Excel files are allowed and must be below 512KB.',
    validation: Yup.mixed()
      .required("Excel File is required")
      .test("fileType", "Only Excel files are allowed", (value) => {
        if (!value) return false;
        const allowedTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        return value && allowedTypes.includes(value.type);
      })
      .test("fileSize", "File size must be less than 512KB", (value) => {
        return value && value.size <= 5242880;
      }),
    accept: ".xlsx,.xls",
  }
}